import { Tab, TabGroup, TabList } from "@headlessui/react";
import { cn } from "@/util/functions";

const Tabs = ({ tabs, onChange, className }) => {
  return (
    <TabGroup onChange={onChange}>
      <TabList className={cn("tw-flex tw-gap-2 sm:tw-gap-3", className)}>
        {tabs.map(({ label, value }) => (
          <Tab
            className="tw-rounded-full tw-border-none tw-outline-none tw-py-1 tw-px-3 tw-text-sm tw-font-semibold focus:tw-outline-none tw-bg-white data-[selected]:tw-bg-[#EBF2FF] data-[focus]:tw-outline-1 data-[focus]:tw-outline-white data-[hover]:tw-bg-slate-100"
            key={value}
          >
            {label}
          </Tab>
        ))}
      </TabList>
    </TabGroup>
  );
};

export default Tabs;
